import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatService } from 'src/app/services/chat.service';

export const CreditBalanceTier = {
  Healthy: 'healthy',
  Low: 'low',
  Critical: 'critical',
} as const;
export type CreditBalanceTier = typeof CreditBalanceTier[keyof typeof CreditBalanceTier];

const LOW_BALANCE_THRESHOLD = 100;

@Component({
  standalone: false,
  selector: 'app-credit-chip',
  templateUrl: './credit-chip.component.html',
  styleUrls: ['./credit-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditChipComponent implements OnInit, OnDestroy {
  readonly creditBalanceTier = CreditBalanceTier;

  visible = false;
  balance = 0;
  tier: CreditBalanceTier = CreditBalanceTier.Healthy;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly chatService: ChatService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.chatService
      .creditBalance$
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.visible = result !== null;
        this.balance = result?.balance ?? 0;
        this.tier = this.computeTier(this.balance);
        this.cdr.markForCheck();
      });

    this.chatService.getCreditBalance().pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private computeTier(balance: number): CreditBalanceTier {
    if (balance <= 0) {
      return CreditBalanceTier.Critical;
    }
    return balance < LOW_BALANCE_THRESHOLD ? CreditBalanceTier.Low : CreditBalanceTier.Healthy;
  }
}
